// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import Vuex from 'vuex'
import { store } from './store'
import axios from "axios";
import { get, post } from "./assets/axios";
import * as echarts from 'echarts';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.prototype.$axios = axios;
Vue.prototype.$get = get;
Vue.prototype.$post = post;

// 域名
// window.api = "http://localhost:8081/employment/pc";
window.api = "https://employment.jlszhgh.com/employment/pc";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js